export default {
  init() {
    // JavaScript to be fired on the home page

    /* eslint-disable */

	$( document ).ready(function() {
			$('.counter').counterUp({
			    delay: 15,
			    time: 2000
			});
		});

	/* eslint-enable */

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
		
	/* eslint-disable */

    $(document).ready(function(){


      var $grid = $('#gallery-grid').imagesLoaded( function() {          
  		  
        // init Packery after all images have loaded
  		  $grid.isotope({
  		    itemSelector: '.grid-item',
  		    percentPosition: true,
  		    masonry: {
  		      // use element for option
  		      columnWidth: '.grid-sizer',
  		      gutter: '.gutter-sizer',
  		    },
  		  });

  		    // This will create a single gallery from all elements that have class "gallery-item"
  			$('.popup-gallery').magnificPopup({
  			  delegate: "a",
  			  type: 'image',
  			  gallery:{
  			    enabled:true
  			  }
  			});
			
     	});



     	$('.slick-quotes').slick({
        arrows: true,
        dots: false,
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst:true,
        fade: true,
        autoplaySpeed: 3500,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
              }
            }
          ]
      });

     	$(window).resize(function(){
		    $('.slick-quotes')[0].slick.refresh();
		  });


    $(document).ready(function(){
    	$('#home-news .card-body').matchHeight();
      $('#home-trisection .trisection').matchHeight();
		});
		$(window).resize(function() {
      $('#home-news .card-body').matchHeight();
      $('#home-trisection .trisection').matchHeight();
    });







        var cookieName = 'ocdCookie'; // The cookie name
        var cookieLifetime = 10; // Cookie expiry in days
       
        /**
         * Set a cookie
         * @param cname - cookie name
         * @param cvalue - cookie value
         * @param exdays - expiry in days
         */
        var _setCookie = function (cname, cvalue, exdays) {
          var d = new Date();
          d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
          var expires = "expires=" + d.toUTCString();
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        };
       
        /**
         * Get a cookie
         * @param cname - cookie name
         * @returns string
         */
        var _getCookie = function (cname) {
          var name = cname + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        };
       
        /**
         * Should the cookie popup be shown?
         */
        var _shouldShowPopup = function () {
          if (_getCookie(cookieName)) {
            return false;
          } else {
            return true;
          }
        };
       
        // Show the cookie popup on load if not previously accepted
        if (_shouldShowPopup()) {
          $('#popup-box').modal('show');
        }
       
        // Modal dismiss btn - consent
        $('#popup-box .close').on('click', function () {
          _setCookie(cookieName, 1, cookieLifetime);
        });

		

    });



    /* eslint-enable */
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/home.js